import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'error',
  `
    ADD_ERROR
    CLEAR_ERROR
    CLEAR_ERRORS
  `
);
